<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="审核状态" prop="contractStatus">
                <a-select :placeholder="$t('请选择')+'审核状态'" v-model="queryParam.contractStatus" style="width: 100%" allow-clear>
                  <a-select-option v-for="(d, index) in this.customDict.ExtraApplyStatusEnum" :key="index" :value="d.type">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="内部商户号" prop="merInnerNo">
                <a-input v-model="queryParam.merInnerNo" :maxLength="32" :placeholder="$t('请输入')+'内部商户号'" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商户注册名称" prop="merRegName">
                <a-input v-model="queryParam.merRegName" :maxLength="32" :placeholder="$t('请输入')+'商户注册名称'" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item label="银联商户号" prop="merCupNo">
                  <a-input v-model="queryParam.merCupNo" :maxLength="32" :placeholder="$t('请输入')+'银联商户号'" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建开始时间')" prop="createBeginTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createBeginTime"
                     :show-time="{defaultValue: moment('00:00:00', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('创建结束时间')" prop="createEndTime">
                  <a-date-picker style="width: 100%" v-model="queryParam.createEndTime"
                     :show-time="{defaultValue: moment('23:59:59', 'HH:mm:ss')}"
                     valueFormat="YYYY-MM-DD HH:mm:ss" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 6 " :sm="6">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('收起') : $t('展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
        <a-button type="primary" @click="handleAdd" v-hasPermi="['shop:extraapplylakala:add']">
          <a-icon type="plus" />{{$t('新增')}}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['shop:extraapplylakala:edit']">
          <a-icon type="edit" />{{$t('修改')}}
        </a-button>
      </div>
      <create-form
        ref="createForm"
        :shopId="shopId"
        :shopType="shopType"
        @ok="getList"
      />
      <a-table
        :scroll="{ x: '140%' }"
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="contractStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExtraApplyStatusEnum" :value="record.contractStatus"/>
        </span>
        <span slot="splitStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.ExtraSplitStatusEnum" :value="record.splitStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['shop:extraapplylakala:edit']">
             <a-icon type="edit" />修改进件信息<br>
          </a>
          <a @click="handleEc(record)" style="color: #f30202" v-if="!record.contractNo">
            <a-icon type="edit" />电子合同签署<br>
          </a>
          <a @click="handleEcDownload(record)"  v-if="record.contractNo">
            <a-icon type="download" />电子合同下载<br>
          </a>
          <a @click="handleLakalaApply(record)" style="color: #f30202"  v-if="!record.contractId">
            <a-icon type="edit" />进件<br>
          </a>
          <a @click="handleLakalaApply(record)"  style="color: #f30202" v-if="record.contractStatus==='MANUAL_AUDIT' || record.contractStatus==='INNER_CHECK_REJECTED' ">
            <a-icon type="edit" />重新进件<br>
          </a>
          <a @click="handleLedgerApply(record)"  style="color: #f30202" v-if="(!record.splitStatus || record.splitStatus==='INVALID' ) && record.contractNo && record.merCupNo">
            <a-icon type="edit" />分账申请开通<br>
          </a>
          <a @click="handleLedgerReceiver(record)"  style="color: #f30202" v-if="record.receiverCount===0 && record.splitStatus==='VALID' ">
            <a-icon type="edit" />申请分账接收方<br>
          </a>
          <a @click="handleBind(record)"  style="color: #f30202" v-if="record.isShowBind ">
            <a-icon type="edit" />绑定分账关系<br>
          </a>
          <a @click="$refs.bindList.handleDetail(record.merCupNo)"  v-if="record.splitStatus && record.merCupNo">
            <a-icon type="eye" />查看分账关系<br>
          </a>
          <a  @click="$refs.subInfoList.handleDetail(record.id)" v-if="record.splitStatus && record.merCupNo">
            <a-icon type="eye" />查看渠道报备<br>
          </a>
           <a  @click="$refs.lakalaBalance.handleDetail(record.shopId)" v-if="record.splitStatus && record.merCupNo">
            <a-icon type="eye" />查看账户余额<br>
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
    <bind-list ref="bindList" ></bind-list>
    <sub-info-list ref="subInfoList"></sub-info-list>
    <lakala-balance ref="lakalaBalance"></lakala-balance>
  </page-header-wrapper>
</template>

<script>
import {
  pageExtraApplyLakala,
  delExtraApplyLakala,
  lakalaApply,
  lakalaApplyEdit,
  lakalaLedgerApply,
  lakalaLedgerUpdate,
  lakalaLedgerApplyReceiverNo,
  ledgerBind,
  getEcUrl,
  downloadEc,
  subInfo
} from '@/api/shop/extraApplyLakala'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import BindList from './modules/BindList.vue'
import SubInfoList from './modules/SubInfoList'
import LakalaBalance from './modules/LakalaBalance'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'ExtraApplyLakala',
  components: {
    CustomDictTag,
    CreateForm,
    BindList,
    SubInfoList,
    LakalaBalance
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      shopId: undefined,
      shopType: undefined,
      queryParam: {
        shopId: undefined,
        orderNo: undefined,
        merRegName: undefined,
        merInnerNo: undefined,
        merCupNo: undefined,
        contractNo: undefined,
        contractId: undefined,
        contractStatus: undefined,
        contractMemo: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        { title: '商户注册名称', dataIndex: 'merRegName', align: 'center' },
        { title: '进件状态', dataIndex: 'contractStatus', scopedSlots: { customRender: 'contractStatus' }, align: 'center' },
        { title: '审核理由', dataIndex: 'contractMemo', align: 'center' },
        { title: '分账状态', dataIndex: 'splitStatus', scopedSlots: { customRender: 'splitStatus' }, align: 'center' },
        { title: '内部商户号', dataIndex: 'merInnerNo', align: 'center' },
        { title: '银联商户号', dataIndex: 'merCupNo', align: 'center' },
        { title: '营业执照名称', dataIndex: 'merBlisName', align: 'center' },
        { title: '法人姓名', dataIndex: 'larName', align: 'center' },
        { title: '法人身份证号码', dataIndex: 'larIdcard', align: 'center' },
        { title: '商户联系人手机', dataIndex: 'merContactMobile', align: 'center' },
        { title: '商户联系人', dataIndex: 'merContactName', align: 'center' },
        { title: '结算账户开户行名称', dataIndex: 'openingBankName', align: 'center' },
        { title: '结算账户账号', dataIndex: 'acctNo', align: 'center' },
        { title: '结算账户名称', dataIndex: 'acctName', align: 'center' },
        { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, align: 'center' },
        { title: this.$t('操作'), dataIndex: 'operation', width: 150, fixed: 'right', scopedSlots: { customRender: 'operation' }, align: 'center' }
      ]
    }
  },
  created () {
    this.pushShopId()
    this.getList()
  },
  mounted() {
    this.pushShopId()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共')+total+this.$t('条')
    },
    pushShopId() {
      let shopId = this.$route.query.shopId;
      if (shopId) {
        this.shopId = shopId;
        const ct = Number(this.$route.query.companyType);
        this.shopType = isNaN(ct) ? 1 : ct;
      }
    },
    getList () {
      this.loading = true
      this.queryParam.shopId = this.shopId
      pageExtraApplyLakala(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    handleAdd() {
      this.$refs.createForm.handleAdd(this.shopId, this.total);
    },
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        shopId: undefined,
        orderNo: undefined,
        merRegName: undefined,
        merInnerNo: undefined,
        merCupNo: undefined,
        contractNo: undefined,
        contractId: undefined,
        contractStatus: undefined,
        contractMemo: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleLakalaApply(record) {
      this.loading = true
      lakalaApply({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("进件成功待审核",3)
          this.getList()
        }
      })
    },
    handleLedgerApply(record) {
      this.loading = true
      lakalaLedgerApply({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("待审核",3)
          this.getList();
        }
      })
    },
    handleLedgerReceiver(record) {
      this.loading = true
      lakalaLedgerApplyReceiverNo({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("待审核, 预计审核日1天",3)
          this.getList()
        }
      })
    },
    handleBind(record) {
      this.loading = true
      ledgerBind({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          this.$message.success("绑定成功待审核",3)
          this.getList();
        }
      })
    },
    handleEc(record) {
      this.loading = true
      getEcUrl({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          let dataUrl = response.data;
          window.open(dataUrl, '_blank')
        }
      })
    },
    handleEcDownload(record) {
      downloadEc({"id":record.id}).then(response => {
        this.loading =false;
        if (response.code==='20001') {
          let dataUrl = response.data;
          this.downloadPureBase64(dataUrl, record.merRegName+"-支付服务合作协议.pdf","application/pdf");
        }
      })
    },
    downloadPureBase64(base64String, fileName, mimeType) {
      let base64Data = base64String;
      const aLink = document.createElement('a')
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      aLink.style.display = 'none'
      aLink.href = URL.createObjectURL(blob)
      aLink.setAttribute('download', fileName)
      document.body.appendChild(aLink)
      aLink.click()
      URL.revokeObjectURL(aLink.href)
      document.body.appendChild(aLink)
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk () {
          return delExtraApplyLakala(that.ids)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(that.$t('删除成功'),3)
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    }
  }
}
</script>
